module.exports = __webpack_public_path__ + "static/6ef70bf10691201c421a9dd128af0e846e520d958054ace40c5ea60235f51f07-4d560d82dc63b9445d723e3a7e30eb5b.png";